/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Management API
 * REST API for portfolio management service.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: info@etractive.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ConfigMatrix,
    ConfigMatrixFromJSON,
    ConfigMatrixToJSON,
} from '../models/ConfigMatrix';
import {
    type ConfigMatrixValue,
    ConfigMatrixValueFromJSON,
    ConfigMatrixValueToJSON,
} from '../models/ConfigMatrixValue';

export interface CreateConfigMatrixRequest {
    id: string;
    key: string;
    configMatrix: ConfigMatrix;
    ignoreDuplicate?: boolean;
}

export interface DeleteConfigMatrixRequest {
    id: string;
    key: string;
}

export interface GetConfigMatricesRequest {
    id: string;
}

export interface GetConfigMatrixRequest {
    id: string;
    key: string;
}

export interface GetConfigMatrixValuesRequest {
    id: string;
    key: string;
}

export interface SetConfigMatrixValuesRequest {
    id: string;
    key: string;
    configMatrixValue: Array<ConfigMatrixValue>;
}

/**
 * 
 */
export class ConfigMatrixApi extends runtime.BaseAPI {

    /**
     * Creates request options for createConfigMatrix without sending the request
     */
    async createConfigMatrixRequestOpts(requestParameters: CreateConfigMatrixRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createConfigMatrix().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling createConfigMatrix().'
            );
        }

        if (requestParameters['configMatrix'] == null) {
            throw new runtime.RequiredError(
                'configMatrix',
                'Required parameter "configMatrix" was null or undefined when calling createConfigMatrix().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ignoreDuplicate'] != null) {
            queryParameters['ignoreDuplicate'] = requestParameters['ignoreDuplicate'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/configmatrix/{key}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ConfigMatrixToJSON(requestParameters['configMatrix']),
        };
    }

    /**
     */
    async createConfigMatrixRaw(requestParameters: CreateConfigMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigMatrix>> {
        const requestOptions = await this.createConfigMatrixRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigMatrixFromJSON(jsonValue));
    }

    /**
     */
    async createConfigMatrix(requestParameters: CreateConfigMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigMatrix> {
        const response = await this.createConfigMatrixRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for deleteConfigMatrix without sending the request
     */
    async deleteConfigMatrixRequestOpts(requestParameters: DeleteConfigMatrixRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteConfigMatrix().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling deleteConfigMatrix().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/configmatrix/{key}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async deleteConfigMatrixRaw(requestParameters: DeleteConfigMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.deleteConfigMatrixRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteConfigMatrix(requestParameters: DeleteConfigMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteConfigMatrixRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for getConfigMatrices without sending the request
     */
    async getConfigMatricesRequestOpts(requestParameters: GetConfigMatricesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getConfigMatrices().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/configmatrix`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getConfigMatricesRaw(requestParameters: GetConfigMatricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConfigMatrix>>> {
        const requestOptions = await this.getConfigMatricesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConfigMatrixFromJSON));
    }

    /**
     */
    async getConfigMatrices(requestParameters: GetConfigMatricesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConfigMatrix>> {
        const response = await this.getConfigMatricesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getConfigMatrix without sending the request
     */
    async getConfigMatrixRequestOpts(requestParameters: GetConfigMatrixRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getConfigMatrix().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getConfigMatrix().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/configmatrix/{key}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getConfigMatrixRaw(requestParameters: GetConfigMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigMatrix>> {
        const requestOptions = await this.getConfigMatrixRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigMatrixFromJSON(jsonValue));
    }

    /**
     */
    async getConfigMatrix(requestParameters: GetConfigMatrixRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigMatrix> {
        const response = await this.getConfigMatrixRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getConfigMatrixValues without sending the request
     */
    async getConfigMatrixValuesRequestOpts(requestParameters: GetConfigMatrixValuesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getConfigMatrixValues().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling getConfigMatrixValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/configmatrix/{key}/values`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getConfigMatrixValuesRaw(requestParameters: GetConfigMatrixValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConfigMatrixValue>>> {
        const requestOptions = await this.getConfigMatrixValuesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConfigMatrixValueFromJSON));
    }

    /**
     */
    async getConfigMatrixValues(requestParameters: GetConfigMatrixValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConfigMatrixValue>> {
        const response = await this.getConfigMatrixValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for setConfigMatrixValues without sending the request
     */
    async setConfigMatrixValuesRequestOpts(requestParameters: SetConfigMatrixValuesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling setConfigMatrixValues().'
            );
        }

        if (requestParameters['key'] == null) {
            throw new runtime.RequiredError(
                'key',
                'Required parameter "key" was null or undefined when calling setConfigMatrixValues().'
            );
        }

        if (requestParameters['configMatrixValue'] == null) {
            throw new runtime.RequiredError(
                'configMatrixValue',
                'Required parameter "configMatrixValue" was null or undefined when calling setConfigMatrixValues().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // apiKey authentication
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("oauth2", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/graph/v1/portfolio/{id}/configmatrix/{key}/values`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));
        urlPath = urlPath.replace('{key}', encodeURIComponent(String(requestParameters['key'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['configMatrixValue']!.map(ConfigMatrixValueToJSON),
        };
    }

    /**
     */
    async setConfigMatrixValuesRaw(requestParameters: SetConfigMatrixValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConfigMatrixValue>>> {
        const requestOptions = await this.setConfigMatrixValuesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConfigMatrixValueFromJSON));
    }

    /**
     */
    async setConfigMatrixValues(requestParameters: SetConfigMatrixValuesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConfigMatrixValue>> {
        const response = await this.setConfigMatrixValuesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
